import React, { useState } from "react";
import Sidebar from "../PPT/Sidebar";
import ImageUploader from "../PPT/ImageUploader";
import { CiCircleInfo } from "react-icons/ci";

function InsertImage({ isOpen, setIsOpen, onInsertImage }) {
  const [imageUrl, setImageUrl] = useState("");

  return (
    <Sidebar
      open={isOpen}
      setOpen={setIsOpen}
      isLoading={!imageUrl}
      title="Insert Image"
      onConfirm={() => {
        console.info("Inserting image and closing sidebar");
        onInsertImage(imageUrl);
        setIsOpen(false);
      }}
    >
      <div>
        <h2 className="text-base font-bold mb-4">Upload Image</h2>

        <ImageUploader
          onSuccess={(url) => {
            console.info("Image uploaded successfully");
            setImageUrl(url);
          }}
        />
      </div>

      <div className="p-2 bg-gray-100 flex gap-3 items-center rounded-md text-sm mt-">
        <CiCircleInfo className="text-3xl mt-1 text-blue-500" /> A slide can
        have up to 2 media. Additional media will be added to a new slide.
      </div>
    </Sidebar>
  );
}

export default InsertImage;
